export default __webpack_public_path__ + "static/home1-5f98d0d37a2db141b777d3460018f3a0.jpg";